import React, { useEffect, useState } from 'react';
import { ArrowUp, Check } from 'lucide-react';

interface ScrollTopIndicatorProps {
  show: boolean;
  onClick: () => void;
  targetRef: React.RefObject<HTMLElement>;
}

const ScrollTopIndicator: React.FC<ScrollTopIndicatorProps> = ({
  show,
  onClick,
  targetRef,
}) => {
  const [isTargetVisible, setIsTargetVisible] = useState(true);

  useEffect(() => {
    const checkVisibility = () => {
      if (targetRef.current) {
        const rect = targetRef.current.getBoundingClientRect();
        // Consider element "visible" when it's fully in view or just slightly scrolled
        setIsTargetVisible(rect.top > -100 && rect.top < 100);
      }
    };

    // Check initial visibility
    checkVisibility();

    // Add scroll listener
    window.addEventListener('scroll', checkVisibility);

    // Cleanup
    return () => window.removeEventListener('scroll', checkVisibility);
  }, [targetRef]);

  // Only show if props.show is true AND target is not visible
  if (!show || isTargetVisible) return null;

  return (
    <div
      className="z-20 fixed bottom-6 right-6 flex flex-col items-center animate-fade-in"
      style={{ animation: 'fade-slide-up 0.5s ease-out' }}
    >
      <div className="bg-white p-3 rounded-lg shadow-2xl mb-2 text-center text-base text-gray-600">
        <p className="whitespace-nowrap">คุณได้เลือกแม่พิมพ์แล้ว</p>
        <p className="whitespace-nowrap text-slate-900 font-bold">
          เลื่อนขึ้นด้านบนเพื่อดำเนินการต่อ
        </p>
      </div>
      <button
        onClick={onClick}
        className="bg-slate-800 hover:bg-slate-900 text-white p-3 rounded-full shadow-lg transform transition-transform hover:scale-110 group"
      >
        <div className="relative">
          <ArrowUp className="h-6 w-6 animate-bounce" />
          <div className="absolute -top-3 -right-3">
            <Check className="h-4 w-4 text-white bg-green-500 rounded-full p-0.5" />
          </div>
        </div>
      </button>
    </div>
  );
};

export default ScrollTopIndicator;
